import type { Carate, Carecommendation } from 'lumen/models';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function generateRecommendationPushData(
  recommendationObject: Carecommendation | null,
  carate: Carate,
  userRecommendationEditedPrice?: number,
) {
  // The difference between the recommended price & the current price
  let recommendationDiffPercent = 0;
  // The difference between the edited price and the recommended price
  let editedRecoDiffPercent = 0;
  // The difference between the edited price and the original price
  let priceDiffPercent = 0;
  const isPriceEdited =
    recommendationObject?.isRecommendedPriceOverwritten ||
    userRecommendationEditedPrice !== undefined;

  const hasRate = carate.hasValue;

  // Case 1: System generated recommendation
  if (recommendationObject) {
    // Recommendation is present, so there should also be a linked carate
    // This should be the standard case where the user pushed a recommendation or edited an existing one
    if (hasRate) {
      const differenceBetweenRecommendationAndOwnRate =
        recommendationObject.recommendedValue - carate.value;
      recommendationDiffPercent =
        differenceBetweenRecommendationAndOwnRate / carate.value;
    }

    if (
      recommendationObject.isRecommendedPriceOverwritten &&
      recommendationObject.overwrittenValue
    ) {
      editedRecoDiffPercent =
        (recommendationObject.overwrittenValue -
          recommendationObject.recommendedValue) /
        recommendationObject.recommendedValue;

      if (hasRate) {
        priceDiffPercent =
          (recommendationObject.overwrittenValue - carate.value) / carate.value;
      }
    }
  } else if (hasRate && userRecommendationEditedPrice !== undefined) {
    // Case 2: no recommendation, but a carate with value exists -> user generated recommendation
    // User has pushed a price on a day without recommendation
    priceDiffPercent =
      (userRecommendationEditedPrice - carate.value) / carate.value;
  }

  // There is also the following edge case: user has edited the price of a day that has no carate value either
  // This should not occur frequently. In this case we basically only have 'isPriceEdited: true' that we can log.

  return {
    hasRate,
    recommendationDiffPercent,
    isPriceEdited,
    editedRecoDiffPercent,
    priceDiffPercent,
  };
}
